import { render } from "./slot.vue?vue&type=template&id=73ddcfff"
import script from "./slot.vue?vue&type=script&lang=js"
export * from "./slot.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__